import React, { useState, useEffect } from 'react';

export default function Product(props) {
  const NO_IMAGE_SRC = 'https://cdn.shopify.com/s/assets/no-image-160-1cfae84eca4ba66892099dcd26e604f5801fdadb3693bc9977f476aa160931ac_120x120.gif';

  const imageSrc = props.item.image && props.item.image.src || NO_IMAGE_SRC

  const onClick = () => {
    props.onClick && props.onClick(props.item)
  }

  return (<div className={`product row ${props.selected ? 'active' : ''}`} title={props.item.title} onClick={onClick}>
      <div className="column small-4">
        <img className="image" src={imageSrc} />
      </div>
      <div className="column small-8 title">{props.item.title}</div>
    </div>)
}
